import {
  AssistantName,
  type InferenceOptions,
  type Message,
} from "@superego/backend";
import { RouteName } from "@superego/routing";
import { PiClockCounterClockwise } from "react-icons/pi";
import { FormattedMessage, useIntl } from "react-intl";
import { useStartConversation } from "../../../business-logic/backend/hooks.js";
import useNavigationState from "../../../business-logic/navigation/useNavigationState.js";
import Link from "../../design-system/Link/Link.js";
import ResultErrors from "../../design-system/ResultErrors/ResultErrors.js";
import Shell from "../../design-system/Shell/Shell.js";
import UserMessageContentInput from "../../widgets/UserMessageContentInput/UserMessageContentInput.js";
import * as cs from "./Ask.css.js";
import Hero from "./Hero.js";
import Welcome from "./Welcome.js";

interface Props {
  initialMessage?: string;
}
export default function Ask({ initialMessage }: Props) {
  const intl = useIntl();
  const { navigateTo } = useNavigationState();

  const { result, mutate, isPending } = useStartConversation();
  const onSend = async (
    userMessageContent: Message.User["content"],
    inferenceOptions: InferenceOptions<"completion">,
  ) => {
    const { success, data } = await mutate(
      AssistantName.Factotum,
      userMessageContent,
      inferenceOptions,
    );
    if (success) {
      navigateTo({ name: RouteName.Conversation, conversationId: data.id });
    }
  };

  return (
    <Shell.Panel slot="Main">
      <Shell.Panel.Header />
      <Shell.Panel.Content className={cs.Ask.panelContent}>
        <Hero />
        <Welcome />
        <UserMessageContentInput
          conversation={null}
          onSend={onSend}
          isSending={isPending}
          placeholder={intl.formatMessage({
            defaultMessage: "How can I help you?",
          })}
          initialMessage={initialMessage}
          autoFocus={true}
        />
        <Link
          to={{ name: RouteName.Conversations }}
          className={cs.Ask.historyLink}
        >
          <PiClockCounterClockwise className={cs.Ask.historyLinkIcon} />
          <FormattedMessage defaultMessage="Previous conversations" />
        </Link>
        {result?.error ? <ResultErrors errors={[result.error]} /> : null}
      </Shell.Panel.Content>
    </Shell.Panel>
  );
}
